import { WorkerContent } from '../workers/generated_workers';

export class WebWorker {
  workerName: string;
  worker!: Worker;
  isActive = false;
  _subscriptions = new Map<string, (payload: any) => void>();
  unsentMessages: { id: string; payload: any }[] = [];

  constructor(workerName: string) {
    this.workerName = workerName;
  }

  emit<PayloadType>(id: string, payload: PayloadType) {
    if (!this.isActive) {
      this.unsentMessages.push({ id, payload });
      return;
    }

    this.worker.postMessage({
      id,
      payload,
    });
  }

  on<PayloadType>(id: string, cb: (payload: PayloadType) => void) {
    this._subscriptions.set(id, cb);
  }

  start() {
    const that = this;

    if (!(this.workerName in WorkerContent))
      throw new Error(`Worker ${this.workerName} not found`);

    const blob = new Blob([WorkerContent[this.workerName]], {
      type: 'application/javascript',
    });

    this.worker = new Worker(URL.createObjectURL(blob));

    this.worker.onmessage = (evt) => {
      if (!('id' in evt.data) || !('payload' in evt.data)) return;

      const { id, payload } = evt.data;

      if (id === '_self') {
        if (payload === 'active') {
          that.isActive = true;

          for (const { id, payload } of that.unsentMessages) {
            that.worker.postMessage({
              id,
              payload,
            });
          }

          that.unsentMessages = [];
        }
      }

      if (that._subscriptions.has(id)) {
        that._subscriptions.get(id)?.(payload);
      }
    };
  }

  stop() {
    if (!this.worker) return;
    this.worker.terminate();
  }
}
